import React, { FC, ReactNode } from 'react';
import styles from './Modal.module.scss';

interface Props {
  handleClose: () => void,
  show: boolean,
  children: ReactNode,
}

const Modal: FC<Props> = ({
  handleClose,
  show,
  children,
}: Props) => {
  const showHideClassName = show ? `${styles.modal} ${styles.displayBlock}` : `${styles.modal} ${styles.displayNone}`;

  return (
    <div className={showHideClassName}>
      <section className={styles.modalMain}>
        {children}
        <div
          role="button"
          onClick={handleClose}
          onKeyDown={handleClose}
          tabIndex={0}
          className={styles.button}
        >
          X
        </div>
      </section>
    </div>
  );
};

export default Modal;
